<app-list-stage [stages]="stages$ | async" [loading]="loading$ | async" [states]="states$ | async"
    (stageSelected$)="navigateToStage($event)" (stagesReorder$)="updateStagesOrder($event)"
    (createStage$)="navigateToCreateStage($event)"></app-list-stage>